import { getFeatureConfig } from '@luna/feature-config';

function getApiTargetLane(apiTarget: string): string | undefined {
    const { apiTargetLanes } = getFeatureConfig(({ devTools }) => devTools);
    return apiTargetLanes[apiTarget];
}

export function getApiTargetLabel(apiTarget: string): string {
    const apiTargetLane = getApiTargetLane(apiTarget);

    if (apiTargetLane) {
        return `${apiTarget} (${apiTargetLane})`;
    }

    return apiTarget;
}
